import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface SistemaDatosDto {
  id?: string;
  nombre?: string;
  id_visible?: number;
  titulo?: string;
  subtitulo?: string;
  pais?: string;
  logo_login?: string | null;
  logo_login_dark?: string | null;
  logo_topbar?: string | null;
  logo_topbar_dark?: string | null;
  img_login?: string | null;
  logo_global_header?: string | null;
  logo_global_header_dark?: string | null;
}

@Injectable({ providedIn: 'root' })
export class SistemaDatosService {
  private readonly http = inject(HttpClient);

  get(): Observable<SistemaDatosDto | null> {
    return this.http.get<SistemaDatosDto>(`${environment.url}sistema-datos`).pipe(
      map((d) => (d ? this.absoluteify(d) : null))
    );
  }

  update(patch: Partial<SistemaDatosDto>): Observable<SistemaDatosDto> {
    return this.http.put<SistemaDatosDto>(`${environment.url}sistema-datos`, patch).pipe(
      map((d) => this.absoluteify(d))
    );
  }

  private absoluteify(d: SistemaDatosDto): SistemaDatosDto {
    const toAbs = (u?: string | null) => {
      if (!u) return u as any;
      if (/^https?:\/\//i.test(u)) return u;
      const base = environment.imagesUrl.endsWith('/') ? environment.imagesUrl : environment.imagesUrl + '/';
      // El backend puede devolver rutas relativas; las normalizamos
      if (u.startsWith('/api/uploads/')) return base + u.replace('/api/uploads/', '');
      if (u.startsWith('/uploads/')) return base + u.replace('/uploads/', '');
      if (u.startsWith('uploads/')) return base + u.replace('uploads/', '');
      if (u.startsWith('/modulos_login/')) return base + u.replace('/', '');
      if (u.startsWith('modulos_login/')) return base + u;
      // Cualquier otra ruta relativa la resolvemos contra el bucket
      if (!u.startsWith('data:') && !u.startsWith('assets/')) return base + u.replace(/^\//, '');
      return u;
    };
    return {
      ...d,
      logo_login: toAbs(d.logo_login) as any,
      logo_login_dark: toAbs(d.logo_login_dark) as any,
      logo_topbar: toAbs(d.logo_topbar) as any,
      logo_topbar_dark: toAbs(d.logo_topbar_dark) as any,
      img_login: toAbs(d.img_login) as any,
      logo_global_header: toAbs(d.logo_global_header) as any,
      logo_global_header_dark: toAbs(d.logo_global_header_dark) as any,
    };
  }
}
